// extracted by mini-css-extract-plugin
export default {"box":"C5XLvkrGQIWs16i01hdG"};